var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgA41 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1085 362",
    style: {
      enableBackground: "new 0 0 1085 362"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.3,359.6c-25.9,0-49.5-7.6-68-23.7c-1.4-1.2-2.7-2.4-4-3.7c-60.6,34.7-121.6,36.6-159.6,3.7 C10.9,310.8-0.3,270.5,8.2,222.2C16,178.7,39.3,132.8,74,93C149.9,6,253.7-23.7,310.5,25.5l-33.6,38.6 c-36.8-31.9-116.1,7.3-164.2,62.5c-28.7,32.9-47.8,70-54,104.6c-3.1,17.3-5.2,48.9,14.7,66.2c20.7,18,59.5,14,100.1-9.1 c-20.4-66.6,18.9-145.4,54.2-185.9c18.6-21.4,41.2-31.3,63.6-27.8c27.9,4.4,48.6,29.2,50.2,60.3c0.8,15.1-2.6,30.8-10.5,48.1 c-14,30.9-33,60.5-54.8,85.5c-10.5,12-21.7,23.1-33.5,33.2c38.8,23.8,112.7-14.3,158.4-66.7l38.7,33.5 C388.7,327,324.9,359.6,271.3,359.6L271.3,359.6z M282.4,124.9c-4.1,0-10.2,4.1-16.1,10.9c-24.2,27.8-49.3,76.9-47.1,118.2 c6.4-6,12.5-12.4,18.4-19.2c18.6-21.3,34.7-46.5,46.7-73c4.4-9.7,6.3-17.6,6-24.3c-0.3-4.8-2.6-11.9-7-12.5 C283,124.9,282.7,124.9,282.4,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M864.1,218.1H831V6.9h-84.3l-76.9,211.2v51.1h110v85.2H831v-85.2h33.1L864.1,218.1L864.1,218.1z M719.9,218.1 l60-164.8v164.8H719.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M940.8,6.9l-71.6,59.3l31,37.9l40.5-36.1v286.5h51.1V6.9H940.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M613.7,354.5h51.1L603.4,6.9h-81.7l-61.4,347.6h51.1l14.5-85.2h73.4L613.7,354.5z M534.5,218.1l28-164.8 l28,164.8H534.5L534.5,218.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1054.2,40.6c3.4-1.5,5.4-4.6,5.4-8.7c0-5.9-4.1-9.7-10.5-9.7h-12.5v30.7h6.1V41.7h5.1l6.2,11.2h7.2 L1054.2,40.6L1054.2,40.6z M1053.5,31.9c0,2.5-1.3,4.6-5.4,4.6h-5.4v-9.2h5.4C1052.1,27.4,1053.5,29.4,1053.5,31.9L1053.5,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1048.1,6.9c-16.9,0-30.7,13.7-30.7,30.7s13.7,30.7,30.7,30.7c16.9,0,30.7-13.7,30.7-30.7S1065,6.9,1048.1,6.9 z M1048.1,62.1c-13.5,0-24.5-11-24.5-24.5s11-24.5,24.5-24.5c13.5,0,24.5,11,24.5,24.5S1061.6,62.1,1048.1,62.1z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgA41);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/a41.385ff329c18e83c3982c9568c29d4ec1.svg";